













import { defineComponent } from "@vue/composition-api";
import { EventPost } from "@scrile/api-provider/dist/projects/scrileConnect/EventPostProvider";
import InfiniteScroll from "@/components/InfiniteScroll";
import EventsListItem from "@/views/PageEvents/components/EventsListItem";

export default defineComponent({
  name: "EventsList",
  components: { InfiniteScroll, EventsListItem },
  props: {
    userId: { type: String, required: true },
    items: { type: Array as () => EventPost[], required: true },
    enableScroll: { type: Boolean, required: true },
  },
});
